/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_ProofInputs */

const en_mk_nav_proof = /** @type {(inputs: Mk_Nav_ProofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proof`)
};

const id_mk_nav_proof = /** @type {(inputs: Mk_Nav_ProofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bukti`)
};

/**
* | output |
* | --- |
* | "Proof" |
*
* @param {Mk_Nav_ProofInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_proof = /** @type {((inputs?: Mk_Nav_ProofInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_ProofInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_proof(inputs)
	return en_mk_nav_proof(inputs)
});